const storageKeys = {
  userToken: 'USER_TOKEN_KEY',
};

export default storageKeys;
